'use client'

import { useEmailCardStore } from '@repo/store/useEmailCardStore'
import { useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles'
import MUIAccordion from '@mui/material/Accordion'
import MUIAccordionSummary from '@mui/material/AccordionSummary'
import MUIAccordionDetails from '@mui/material/AccordionDetails'
import MUIExpandedMoreIcon from '@mui/icons-material/ExpandMore'
import MUITypography from '@mui/material/Typography'

export const EmailSidebarCard = ({ children, title, id, sx, disabled = true }: EmailSidebarCardProps) => {
  const theme = useTheme()

  const { setCardId, handleCardToggle, cardExpanded } = useEmailCardStore()

  useEffect(() => {
    setCardId(id)
  }, [id, setCardId])

  const handleAccordionChange = () => {
    if (!disabled) {
      handleCardToggle(id)
    }
  }

  return (
    <MUIAccordion
      expanded={cardExpanded === id}
      id={id}
      onChange={() => handleAccordionChange()}
      disableGutters
      disabled={disabled}
      data-testid="EmailSidebarCard"
      sx={{
        backgroundColor: disabled ? theme.palette.grey[300] : 'white',
        borderRadius: 1,
        boxShadow: 'none',
        pl: 4,
        pr: 4,
        opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        [`&:before`]: {
          content: 'none'
        },
        ...sx
      }}
    >
      <MUIAccordionSummary
        expandIcon={<MUIExpandedMoreIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
        sx={{ minHeight: '64px', padding: 0 }}
      >
        <MUITypography variant="h6" sx={{ mb: 0, textTransform: 'uppercase', pointerEvents: 'none' }}>
          {title}
        </MUITypography>
      </MUIAccordionSummary>
      <MUIAccordionDetails sx={{ padding: 0 }}>{children}</MUIAccordionDetails>
    </MUIAccordion>
  )
}

type EmailSidebarCardProps = {
  children: React.ReactNode
  title: string
  id: string
  sx?: React.CSSProperties
  disabled?: boolean
}
